import axios from "axios"

export const downloadFile = async (url, filename) => {
  await axios
    .get(url, {
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/*'
      }
    })
    .then(response => {
      let blob = new Blob([response.data], { type: 'application/*' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    })
    .catch(err => {
      console.error(err)
    })
}

export const downloadFileWithoutName = async (url) => {
  await axios
    .get(url, {
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/*'
      }
    })
    .then(response => {
      console.debug('blob', response)
      const filename = getFilename(response.headers.get('content-disposition'))
      let blob = new Blob([response.data], { type: 'application/*' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    })
    .catch(err => {
      console.error(err)
    })
}

function getFilename(header) {
  if (!header) return null;

  // 1. filename*=charset'lang'percent-encoded (takes precedence)
  const star = /filename\*\s*=\s*([^']*)'[^']*'([^;]+)/i.exec(header);
  if (star) {
    try {
      return decodeURIComponent(star[2].trim());
    } catch {
      // malformed encoding -> fall through to plain filename
    }
  }

  // 2. filename="quoted string" (with \" escapes) or filename=token
  const plain = /filename\s*=\s*(?:"((?:[^"\\]|\\.)*)"|([^;]+))/i.exec(header);
  if (plain) {
    return (plain[1] ?? plain[2]).replace(/\\(.)/g, '$1').trim();
  }

  return null;
}

export const downloadPrintingInformation = async (documentIdentifier, exhibitionSlug, filename) => {
  await downloadFile('/' + exhibitionSlug + '/download/printing-information/' + documentIdentifier, filename)
}